'use strict';

var React = require('react');
var functions = require('../../../helpers/functions.js');
var filterPopin_styles = require('./filterPopin.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FilterPopin = ({ id, node = { current: null }, queryParam, colKey, isPopinRightSide = false, $top, $left, addToQueryParams = functions.noop, removeFromQueryParams = functions.noop, defaultOrder = 'date', labelOrderTitle = 'Option de tri', labelOrderDate = 'Tri désactivé', labelOrderAsc = 'Trier de A \u2192 Z', labelOrderDesc = 'Trier de Z \u2192 A', }) => {
    const [sortValue, setSortValue] = React.useState(queryParam?.key === colKey && queryParam?.order ? queryParam.order : defaultOrder);
    const onSortBy = (param) => {
        removeFromQueryParams({ key: colKey });
        if (param.order !== defaultOrder) {
            addToQueryParams({ ...param, key: colKey });
        }
    };
    const makeOnRadioChange = (order) => (e) => {
        setSortValue(e.target.value);
        onSortBy({ order });
    };
    return (React__default.default.createElement(filterPopin_styles.ContainerStyled, { id: id, ref: node, isPopinRightSide: isPopinRightSide, "$top": $top, "$left": $left },
        React__default.default.createElement(filterPopin_styles.FilterTitle, null, labelOrderTitle),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-date`, name: "filter", value: "date", checked: sortValue === 'date', onChange: makeOnRadioChange('date') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-date` }, labelOrderDate)),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-asc`, name: "filter", value: "asc", checked: sortValue === 'asc', onChange: makeOnRadioChange('asc') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-asc` }, labelOrderAsc)),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-desc`, name: "filter", value: "desc", checked: sortValue === 'desc', onChange: makeOnRadioChange('desc') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-desc` }, labelOrderDesc))));
};

exports.FilterPopin = FilterPopin;
//# sourceMappingURL=filterPopin.js.map
